// extracted by mini-css-extract-plugin
export var title = "styles-module__title___PW5uO";